import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";

import App from "./App";
import { CookiesProvider } from "react-cookie";
const root = ReactDOM.createRoot(document.getElementById("root"));
export default function Index() {
  return (
    <React.StrictMode>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </React.StrictMode>
  );
}
root.render(<Index />);
